import React, { useState, useEffect } from 'react';

const VendorDescription = () => {
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  // Get logged in user info
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const userId = user.id;

  useEffect(() => {
    // Fetch current description
  fetch(`${process.env.REACT_APP_SERVICE_DOMAIN}/api/user/${userId}`)
      .then(res => res.json())
      .then(data => {
        setDescription(data.description || '');
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [userId]);

  const handleSave = async (e) => {
    e.preventDefault();
    setMessage('');
    try {
  const res = await fetch(`${process.env.REACT_APP_SERVICE_DOMAIN}/api/user/${userId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ description }),
      });
      const data = await res.json();
      if (res.ok) {
        setMessage('Description updated successfully!');
        // Optionally update localStorage
        localStorage.setItem('user', JSON.stringify({ ...user, description }));
      } else {
        setMessage(data.message || 'Failed to update description.');
      }
    } catch {
      setMessage('Failed to update description.');
    }
  };

  if (loading) return <div style={styles.loading}>Loading...</div>;

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Vendor Description</h2>
      <form onSubmit={handleSave} style={styles.form}>
        <label style={styles.label}>Description:</label>
        <h6>Please include your qualifications, experience, and any relevant certifications, so your profile stands out.</h6>
        <textarea
          style={styles.textarea}
          value={description}
          onChange={e => setDescription(e.target.value)}
          rows={7}
          placeholder="Describe your services, experience, or anything you'd like customers to know..."
        />
        <button style={styles.button} type="submit">Save</button>
        {message && <div style={styles.message}>{message}</div>}
      </form>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '600px',
    margin: '40px auto',
    padding: '32px',
    background: '#fff',
    borderRadius: '14px',
    boxShadow: '0 4px 24px rgba(141,110,54,0.10)',
    fontFamily: 'Segoe UI, Arial, sans-serif',
  },
  title: {
    marginBottom: '28px',
    color: '#4078c0',
    fontSize: '1.7rem',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '1px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  label: {
    fontWeight: 'bold',
    color: '#8d6e36',
    fontSize: '1.08rem',
    marginBottom: '6px',
  },
  textarea: {
    padding: '12px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '1rem',
    minHeight: '120px',
    resize: 'vertical',
    marginBottom: '8px',
  },
  button: {
    background: '#388e3c',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    padding: '10px 22px',
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px #c8e6c9',
    transition: 'background 0.2s',
    marginTop: '8px',
    alignSelf: 'flex-start',
  },
  message: {
    textAlign: 'center',
    color: '#388e3c',
    fontWeight: 'bold',
    marginTop: '8px',
  },
  loading: {
    textAlign: 'center',
    color: '#4078c0',
    fontSize: '1.2rem',
    fontWeight: 'bold',
    marginTop: '40px',
    letterSpacing: '1px',
  },
};

export default VendorDescription;